import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, useMediaQuery } from '@mui/material';
import { IconLightning } from '../../../../../../assets/icons/icon-lightning';
import { IconPlus } from '../../../../../../assets/icons/icon-plus';
import { IconQuestionCircle } from '../../../../../../assets/icons/icon-question-circle';
import { IconGroups, IconShare } from '../../../../../../assets/popup-nav-icons';
import { Header } from '../../../../../../components/header';
import { useInstallationContext } from '../../../../../../context/installation';
import { useShareRedirect } from '../../../../../../modules/installation-share/hooks/use-share-redirect';
import { ROUTES } from '../../../../../../routes/routes';
import { useDevicesAndChannelsContext } from '../../../../context/devices-and-channels';
import { usePriceConditionSupported } from '../../../../hooks/meters/use-price-condition-supported';
import { TariffOperator } from '../../../channel-details/optimizer/configuration/types/tariff-kind';
import { useAddDevice } from '../../../device-add/hooks/use-add-device';
import { DashboardActionItem } from '../../components/dashboard-action-item/dashboard-action-item';
import { useDashboardContext } from '../../context/dashboard-context';

export const DashboardActions: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('dashboard');
  const { selectedInstallationId } = useInstallationContext();
  const { channelList } = useDevicesAndChannelsContext();
  const { addDevice } = useAddDevice();
  const { shareInstallation } = useShareRedirect();
  const { priceConditionSupported } = usePriceConditionSupported();
  const { tariffOperator } = useDashboardContext();
  const isSmall = useMediaQuery('(max-width:330px)');

  const triggerTileVisible = channelList.length > 0;
  const isTauron = tariffOperator === TariffOperator.Tauron;

  if (!selectedInstallationId) return null;

  const actionItems = [
    {
      title: t('actions.addDevice'),
      icon: <IconPlus />,
      onClick: addDevice,
    },
    {
      title: t('actions.shareInstallation'),
      icon: <IconShare />,
      onClick: () => shareInstallation(selectedInstallationId),
    },
    ...(isTauron
      ? [
          {
            title: t('actions.tariffTauron'),
            icon: <img height={40} width={40} src="/images/tauron.png" alt="tauron" />,
            onClick: () => navigate(ROUTES.TariffOverview()),
            color: '#D22F7C',
          },
        ]
      : []),
    ...(priceConditionSupported && isTauron
      ? [
          {
            title: t('actions.g13s'),
            icon: <img height={40} width={40} src="/images/tauron.png" alt="tauron" />,
            onClick: () => navigate(`${ROUTES.TriggerCreate()}?g13s=true`),
            color: '#D22F7C',
          },
        ]
      : []),

    {
      title: t('actions.createGroup'),
      icon: <IconGroups />,
      onClick: () => navigate(ROUTES.GroupCreate()),
    },
    ...(triggerTileVisible
      ? [
          {
            title: t('actions.trigger'),
            icon: <IconLightning />,
            onClick: () => navigate(ROUTES.TriggerCreate()),
          },
        ]
      : []),
    {
      title: t('actions.support'),
      icon: <IconQuestionCircle />,
      onClick: () => navigate(ROUTES.Support()),
    },
  ];

  return (
    <Box paddingLeft={3} paddingRight={3}>
      <Header title={t('actions.header')} />
      <Grid container spacing={2} marginBottom={6}>
        {actionItems.map((item, index) => (
          <Grid size={{ xs: isSmall ? 12 : 6, sm: 6 }} key={index}>
            <DashboardActionItem {...item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
